/*
 * @Author: taojinchao
 * @Date: 2023-09-18 14:19:25
 * @LastEditors: taojinchao
 * @LastEditTime: 2023-09-18 14:20:41
 * @Description: 枚举类
 */
export enum StatAction {
  /** 点击 */
  CLICK = 'click',
  /** 滑动 */
  SLIDE = 'slide',
  /** 元素曝光 */
  SHOW = 'show',
  /** 停留 */
  STAY = 'stay',
  /** 元素消失 */
  DIS = 'dis',
  /** 悬浮 */
  HOVER = 'hover',
  /** 拉动 */
  PULL = 'pull',
  /** 双击 */
  DCLICK = 'dclick',
  /** 应用启动 */
  START = 'start',
  /** 长按 */
  PRESS = 'press',
}
